import config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupRequestInterceptor,
} from '@gasbi/shared/common/utils/http';

// Cookie (BFF) session (GSB-7560): every request carries X-CSRF for the API's CSRF guard, and a
// 401 (no session) navigates to the cabinet API's login endpoint. Someone who signed in but has
// no place in this cabinet gets a 403, which the session bootstrap shows as "not authorized" -
// so, unlike the former token flow, a 401 interceptor cannot hide that case.
const instance = initializeHttp(
  config.VITE_API_URL,
  [
    setupRequestInterceptor,
    setupCsrfInterceptor,
    setupCookieUnauthorizedInterceptorFabric('/api/login'),
  ],
  {
    // `indexes: null` serializes array params as repeated `key=value` pairs (ASP.NET Core's expected format) instead of axios's default `key[]=value`.
    paramsSerializer: { indexes: null },
  },
);

export default instance;
